import * as actionTypes from "./actionTypes";

export const signature = params => ({
	type: actionTypes.SIGNATURE_ACTION,
	params
});

export const draftSignatureImage = params => ({
	type: actionTypes.DRAFT_SIGNATURE_IMAGE_ACTION,
	params
});

export const getFileTimelineCRM = () => ({
	type: actionTypes.GET_FILE_TIMELINE_CRM_ACTION
});

export const setFileTimelineCRM = params => ({
	type: actionTypes.SET_FILE_TIMELINE_CRM_ACTION,
	params
});

export const postConfirmTimelineCRM = params => ({
	type: actionTypes.CONFIRM_TIMELINE_CRM_ACTION,
	params
});
